import { type ComponentPropsWithoutRef } from 'react'

import { Footer } from '@components/ui-core/footer/footer'

import { footerContent } from './content'

export type PageFooterProps = ComponentPropsWithoutRef<'footer'>

export function PageFooter(rest: PageFooterProps) {
  return <Footer navColumns={footerContent} data-color-scheme="dark" {...rest} />
}
